"use client";
import { useState } from "react";

/*import "../App.scss";*/
import Hero from "../sections/hero/Hero";
import Advantages from "../sections/advantages/Advantages";
import About from "../sections/about/About";
import Guarantee from "../sections/guarantee/Guarantee";
import Prices from "../sections/prices/Prices";
import Enough from "../sections/enough/Enough";
import Faq from "../sections/faq/Faq";

function LandingClient({ block }: { block: any }) {
  const [activeTab, setActiveTab] = useState("how-to");
  const [activeAccordion, setActiveAccordion] = useState("");

  return (
    <>
      <Hero block={block} />
      <Advantages />
      <About />
      <Guarantee
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        setActiveAccordion={setActiveAccordion}
        block={block}
      />
      <Prices block={block} />
      <Enough block={block} />
      <Faq
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        activeAccordion={activeAccordion}
        setActiveAccordion={setActiveAccordion}
        block={block}
      />
    </>
  );
}

export default LandingClient;
